import axios from 'axios';

const resolveApiUrl = () => {
  const configuredUrl = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');
  const backendUrl = configuredUrl || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8001');
  return `${backendUrl}/api`;
};

const API_URL = resolveApiUrl();

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Request interceptor to normalize content type.
api.interceptors.request.use(
  (config) => {
    // For FormData: remove Content-Type so browser sets multipart + boundary.
    // For JSON bodies: explicitly set application/json.
    if (config.data instanceof FormData) {
      // axios 1.x uses AxiosHeaders with .delete() method
      if (typeof config.headers.delete === 'function') {
        config.headers.delete('Content-Type');
      } else {
        delete config.headers['Content-Type'];
      }
    } else if (config.data !== undefined) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?.skipAuthRedirect) {
      window.location.href = window.location.pathname.startsWith('/portal') ? '/portal' : '/';
    }
    return Promise.reject(error);
  }
);

export default api;
